if (!customElements.get('monties-scroll-hero')) {
 customElements.define('monties-scroll-hero', class extends HTMLElement {
  connectedCallback() {
   if(this.events)return;
   this.events=new AbortController();
   this.preference=matchMedia('(prefers-reduced-motion: reduce)');
   const schedule=()=>{if(!this.frame)this.frame=requestAnimationFrame(()=>{this.frame=0;this.paint()})};
   this.preference.addEventListener('change',schedule,{signal:this.events.signal});
   window.addEventListener('scroll',schedule,{capture:true,passive:true,signal:this.events.signal});
   this.closest('.page-wrapper')?.addEventListener('scroll',schedule,{passive:true,signal:this.events.signal});
   window.addEventListener('resize',schedule,{passive:true,signal:this.events.signal});
   this.paint();
  }
  paint(){
   const enabled=innerWidth>=750&&this.classList.contains('m4-hero--motion')&&!this.preference.matches;
   const p=enabled?Math.max(0,Math.min(1,-this.getBoundingClientRect().top/(this.offsetHeight*.75))):0;
   const ease=p*p*(3-2*p),mobile=innerWidth<750;
   this.dataset.scrollProgress=p.toFixed(3);
   this.style.setProperty('--m4-case-y',(-ease*(mobile?40:85))+'px');
   this.style.setProperty('--m4-case-rotate',(-9+ease*16)+'deg');
   this.style.setProperty('--m4-case-scale',String(1+ease*.07));
   this.style.setProperty('--m4-wallet-x',(ease*(mobile?8:25))+'px');
   this.style.setProperty('--m4-wallet-y',(-ease*(mobile?95:165))+'px');
   this.style.setProperty('--m4-wallet-rotate',(14-ease*25)+'deg');
   this.style.setProperty('--m4-label-y',(-ease*45)+'px');
  }
  disconnectedCallback(){this.events?.abort();this.events=null;cancelAnimationFrame(this.frame);this.frame=0}
 });
}
